// extracted by mini-css-extract-plugin
export default {"contact-text":"contact-text_h0ldd","contactText":"contact-text_h0ldd","email":"email_rvsFD"};